/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_AsideInputs */

const en_services_aside = /** @type {(inputs: Services_AsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each one shows its next open time.`)
};

const pl_services_aside = /** @type {(inputs: Services_AsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przy każdych zajęciach widać najbliższy wolny termin.`)
};

/**
* | output |
* | --- |
* | "Each one shows its next open time." |
*
* @param {Services_AsideInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const services_aside = /** @type {((inputs?: Services_AsideInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_AsideInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_services_aside(inputs)
	return en_services_aside(inputs)
});